<val-carte-dashboard [titre]="'dashboard.carte-factures-transmises.titre' | transloco" [colonnes]="3" [lignes]="2"
	[chargementEnCours]="chargementEnCours" [estEnErreur]="estEnErreur">

	<ng-template>
	@if (donnees)
	{

	<div class="val-carte-factures-transmises-stats">

		<!-- Volume total -->
		<div class="val-carte-stat val-carte-stat-neutre">
			<div class="val-carte-stat-libelle">
				{{ 'dashboard.carte-factures-transmises.volume-total.libelle' | transloco }}
			</div>
			<div class="val-carte-stat-data">
				<div class="val-carte-stat-nombre">
					{{ donnees.nombreVolumeTotal }}
				</div>
				<div class="val-carte-stat-data-right">
					<div class="val-carte-stat-montant">
						{{ donnees.montantTtcVolumeTotal | translocoCurrency }}
					</div>
				</div>
			</div>
		</div>

		<!-- Volume à régulariser -->
		<div class="val-carte-stat val-carte-stat-alerte">
			<div class="val-carte-stat-libelle">
				{{ 'dashboard.carte-factures-transmises.volume-a-reguler.libelle' | transloco }}
			</div>
			<div class="val-carte-stat-data">
				<div class="val-carte-stat-nombre val-carte-stat-alerte-texte">
					{{ donnees.nombreVolumeARegulariser }}
				</div>
				<div class="val-carte-stat-data-right">
					<div class="val-carte-stat-montant val-carte-stat-alerte-texte">
						{{ donnees.montantTtcVolumeARegulariser | translocoCurrency }}
					</div>
					<div class="val-carte-stat-pourcentage val-carte-stat-alerte-texte">
						{{ pourcentageVolumeARegulariser }}%
						{{ 'dashboard.carte-factures-transmises.volume-a-reguler.du-volume-total' | transloco }}
					</div>
				</div>
			</div>
		</div>

	</div>

	}
	</ng-template>

</val-carte-dashboard>
